import React from "react";
import { Pagination, PaginationWrapper } from "./Pagination.styled";
import { useSearchParams } from "react-router-dom";
import { changeQueryParameters } from "../../utils/helpers";

const CustomPagination = ({
  totalRecords,
  onPaginationClicked,
  currentPage,
  rowsPerPage = 10,
}) => {
  const noOfPages = Math.ceil(totalRecords / rowsPerPage);

  const [searchParams, setSearchParams] = useSearchParams();
  const parsedPage = Number(searchParams.get("offset"));
  const limit = Number(searchParams.get("limit") || rowsPerPage);

  const page = currentPage
    ? currentPage
    : !isNaN(parsedPage) && parsedPage > 0
    ? (parsedPage + limit) / limit
    : 1;

  const handleChange = (_, value) => {
    const queryParams = changeQueryParameters(searchParams, {
      offset: value * limit - limit,
    });

    onPaginationClicked
      ? onPaginationClicked(value * limit - limit)
      : setSearchParams(queryParams);
  };

  return (
    <PaginationWrapper>
      <Pagination
        page={page}
        onChange={handleChange}
        count={noOfPages}
        variant="outlined"
        shape="rounded"
        defaultPage={page}
        boundaryCount={2}
        siblingCount={0}
      />
    </PaginationWrapper>
  );
};

export default CustomPagination;
